import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskCardNumber'
})
export class MaskCardNumberPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    let result = '';
    if (value && value.length > 4) {
      value.split('').map((char, index) => {
        if (index < value.length - 4) {
          result += '*';
        } else {
          result += char;
        }
      });
      return result;
    }
    return value;
  }

}
